import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const statusMapColor: { [key: string]: string } = {
  normal: '#E00000',
  tg24: '#9e1010',
  hover: '#DB292A',
  pressed: '#E00000',
  disabled: '#9F9F9F',
};

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
    <rect width={props.width} height={props.height} fill={statusMapColor[props.status]} />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 11.5414C13 11.4183 13.0399 11.2989 13.1131 11.2028C13.2909 10.9695 13.615 10.932 13.8369 11.119L18.5344 15.0776C18.5638 15.1024 18.5906 15.1305 18.6141 15.1614C18.792 15.3947 18.7563 15.7355 18.5344 15.9224L13.8369 19.8811C13.7455 19.9581 13.6319 20 13.5149 20C13.2305 20 13 19.7576 13 19.4586V11.5414Z"
    />
  </svg>
);

const IconMediaPlay: React.FC<IIcon> = (props: ReactProps) => <Icon {...props} svg={svg} />;
export interface IIconMediaPlay extends IIcon {}

export default IconMediaPlay;
